<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('form_label_search') || '版本号/版本序号搜索...'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>

            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditFormDialog', {type: 'add'})"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>{{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="750px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_versionNo') || '版本号'">
              <el-input
                v-model.trim="form.versionNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('form_label_versionNumber') || '版本序号'">
              <el-input-number
                v-model.trim="form.versionNumber"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                style="width:100%"
                :min="1"
                :step="1"
                :precision="0"
                controls-position="right"
                size="small"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-form-item :label="$l('form_label_publishTime') || '发布时间'">
            <el-col :span="11">
              <el-date-picker
                v-model="form.beginPublishTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_time') || '选择日期'"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="form.endPublishTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_time') || '选择日期'"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_versionStatus') || '版本状态'">
              <el-checkbox-group v-model="form.versionStatusList">
                <el-checkbox label="N" name="type">{{
                  $l('form_label_versionStatus_N') || '新增'
                }}</el-checkbox>
                <el-checkbox label="P" name="type">{{
                  $l('form_label_versionStatus_P') || '发布'
                }}</el-checkbox>
                <el-checkbox label="D" name="type">{{
                  $l('form_label_versionStatus_D') || '删除'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyword: '',
  versionStatusList: ['P', 'N'],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: {...initForm},
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({isReset = true} = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = {...initForm}
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
